<template>
    <div>
        <div>
            <ul class="nav nav-pills" role="tablist">
                <li v-if="starshop_data.admin_data.collective" class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#starshop_data_collective" role="tab"
                       aria-selected="false">
                        {{ $t('dashboard.label.payment_facilitator') }}
                    </a>
                </li>
<!--                <li v-if="starshop_data.admin_data.ivr" class="nav-item">-->
<!--                    <a class="nav-link" data-toggle="tab" href="#starshop_data_ivr" role="tab" aria-selected="false">-->
<!--                        {{ $t('dashboard.label.ivr') }}-->
<!--                    </a>-->
<!--                </li>-->
                <li v-if="starshop_data.admin_data.profit" class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#starshop_profit_data" role="tab" aria-selected="false">
                        {{ $t('dashboard.label.company_profit') }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="tab-content">
            <div v-if="starshop_data.admin_data.collective" id="starshop_data_collective" class="tab-pane active">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="card mb-3 bg-gr-oryelo">
                                    <div class="card-body">
                                        {{ $t('label.last_updated') }}
                                        <h5 class="fix-margin" style="direction: ltr">
                                            {{ starshop_data.admin_data.last_update }}
                                        </h5>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="card mb-3 bg-gr-oryelo">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.daily_transactions') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.collective.today_tr }}
                                            <span style="font-size: 1.2rem">
                                                {{ ' ' + $t('currency.rial') }}
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card mb-3 bg-gr-grass">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.monthly_transactions') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.collective.monthly_tr }}
                                            <span style="font-size: 1.2rem">
                                                {{ ' ' + $t('currency.rial') }}
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="card mb-3 bg-gr-bluvio">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.total_transactions') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.collective.total_tr }}
                                            <span style="font-size: 1.2rem">
                                                {{ ' ' + $t('currency.rial') }}
                                            </span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="col-md-3">-->
<!--                                <div class="card mb-3 bg-gr-ored ">-->
<!--                                    <div class="card-body">-->
<!--                                        {{ $t('dashboard.label.balance') }}-->
<!--                                        <h5 class="fix-margin">-->
<!--                                            {{ starshop_data.admin_data.collective.balance }}-->
<!--                                            <span style="font-size: 1.2rem">-->
<!--                                                {{ ' ' + $t('currency.rial') }}-->
<!--                                            </span>-->
<!--                                        </h5>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-3">-->
<!--                                <div class="card mb-3 bg-gr-midivio">-->
<!--                                    <div class="card-body">-->
<!--                                        {{ $t('dashboard.label.settling_balance') }}-->
<!--                                        <h5 class="fix-margin">-->
<!--                                            {{ starshop_data.admin_data.collective.settling }}-->
<!--                                            <span style="font-size: 1.2rem">-->
<!--                                                {{ ' ' + $t('currency.rial') }}-->
<!--                                            </span>-->
<!--                                        </h5>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-3">-->
<!--                                <div class="card mb-3 bg-gr-pinkp">-->
<!--                                    <div class="card-body">-->
<!--                                        {{ $t('dashboard.label.settled_balance') }}-->
<!--                                        <h5 class="fix-margin">-->
<!--                                            {{ starshop_data.admin_data.collective.settled }}-->
<!--                                            <span style="font-size: 1.2rem">-->
<!--                                                {{ ' ' + $t('currency.rial') }}-->
<!--                                            </span>-->
<!--                                        </h5>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="col-md-3">
                                <div class="card mb-3 bg-gr-viop">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.settling_count') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.collective.settling_count }}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="starshop_data.admin_data.profit" id="starshop_profit_data" class="tab-pane">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-ored">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.daily_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.profit.daily }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-ored">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.monthly_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.profit.monthly }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-ored">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.total_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.profit.total }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-oryelo">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.daily_net_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.profit.dailyNet }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-oryelo">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.monthly_net_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.profit.monthlyNet }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-oryelo">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.total_net_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.profit.totalNet }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-bluvio">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.marketing.daily_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.marketingProfit.daily }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-bluvio">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.marketing.monthly_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.marketingProfit.monthly }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-bluvio">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.marketing.total_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.marketingProfit.total }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-viop">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.wallet_profit.daily_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.walletProfit.daily }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-viop">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.wallet_profit.monthly_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.walletProfit.monthly }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-viop">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.wallet_profit.total_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.walletProfit.total }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-lime">
                                <div class="card-body">
                                  {{ $t('dashboard.label.upcoming_wage.daily_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.upcomingWageProfit.daily }}
                                    <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-lime">
                                <div class="card-body">
                                  {{ $t('dashboard.label.upcoming_wage.monthly_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.upcomingWageProfit.monthly }}
                                    <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-lime">
                                <div class="card-body">
                                  {{ $t('dashboard.label.upcoming_wage.total_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.upcomingWageProfit.total }}
                                    <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-mint">
                                <div class="card-body">
                                  {{ $t('dashboard.label.card_to_card_subscription.daily_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.cardToCardSubscription.daily }}
                                    <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-mint">
                                <div class="card-body">
                                  {{ $t('dashboard.label.card_to_card_subscription.monthly_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.cardToCardSubscription.monthly }}
                                    <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-mint">
                                <div class="card-body">
                                  {{ $t('dashboard.label.card_to_card_subscription.total_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.cardToCardSubscription.total }}
                                    <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-mint">
                                <div class="card-body">
                                  {{ $t('dashboard.label.card_to_card_wallet_charge.daily_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.cardToCardWalletCharge.daily }}
                                    <span style="font-size: 1.2rem">{{' ' + $t('currency.rial')}}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-mint">
                                <div class="card-body">
                                  {{ $t('dashboard.label.card_to_card_wallet_charge.monthly_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.cardToCardWalletCharge.monthly }}
                                    <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-mint">
                                <div class="card-body">
                                  {{ $t('dashboard.label.card_to_card_wallet_charge.total_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.cardToCardWalletCharge.total }}
                                    <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-ored">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.ivr_daily_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.ivr_profit.daily }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-ored">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.ivr_monthly_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.ivr_profit.monthly }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-ored">
                                    <div class="card-body">
                                        {{ $t('dashboard.label.ivr_total_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.ivr_profit.total }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
<!--                            <div class="col-md-6">-->
<!--                                <div class="card mb-3 bg-gr-grass">-->
<!--                                    <div class="card-body">-->
<!--                                        {{ $t('dashboard.label.card_to_card.monthly_profit') }}-->
<!--                                        <h5 class="fix-margin">-->
<!--                                            {{ starshop_data.admin_data.cardToCardProfit.monthly }}-->
<!--                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>-->
<!--                                        </h5>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-6">-->
<!--                                <div class="card mb-3 bg-gr-grass">-->
<!--                                    <div class="card-body">-->
<!--                                        {{ $t('dashboard.label.card_to_card.total_profit') }}-->
<!--                                        <h5 class="fix-margin">-->
<!--                                            {{ starshop_data.admin_data.cardToCardProfit.total }}-->
<!--                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>-->
<!--                                        </h5>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="col-md-6">
                                <div class="card mb-3 bg-gr-aqua">
                                    <div class="card-body">
                                      {{ $t('dashboard.label.sms_wallet_charging.monthly_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.smsWalletChargeProfit.monthly }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card mb-3 bg-gr-aqua">
                                    <div class="card-body">
                                      {{ $t('dashboard.label.sms_wallet_charging.total_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.smsWalletChargeProfit.total }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-berry">
                                <div class="card-body">
                                  {{ $t('dashboard.label.net_profit.daily_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.netProfit.daily }}
                                    <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card mb-3 bg-gr-berry">
                                    <div class="card-body">
                                      {{ $t('dashboard.label.net_profit.monthly_profit') }}
                                        <h5 class="fix-margin">
                                            {{ starshop_data.admin_data.netProfit.monthly }}
                                            <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card mb-3 bg-gr-berry">
                                <div class="card-body">
                                  {{ $t('dashboard.label.net_profit.total_profit') }}
                                  <h5 class="fix-margin">
                                    {{ starshop_data.admin_data.netProfit.total }}
                                    <span style="font-size: 1.2rem">{{ ' ' + $t('currency.rial') }}</span>
                                  </h5>
                                </div>
                              </div>
                            </div>
                            <div class="line-divider mb-3 mt-3"></div>

                            <div class="line-divider mb-3 mt-3"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <div v-if="starshop_data.admin_data.ivr" id="starshop_data_ivr" class="tab-pane">-->
<!--            <div class="panel panel-default mb-3">-->
<!--                <div class="panel-body">-->
<!--                    <div class="row">-->
<!--                        <div class="col-md-4">-->
<!--                            <div class="card mb-3 bg-gr-grass">-->
<!--                                <div class="card-body">-->
<!--                                    {{ $t('dashboard.label.daily_transactions') }}-->
<!--                                    <h5 class="fix-margin">-->
<!--                                        {{ starshop_data.admin_data.ivr.today_tr }}-->
<!--                                        <span style="font-size: 1.2rem">-->
<!--                                                    {{ ' ' + $t('currency.rial') }}-->
<!--                                                </span>-->
<!--                                    </h5>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-4">-->
<!--                            <div class="card mb-3 bg-gr-oryelo">-->
<!--                                <div class="card-body">-->
<!--                                    {{ $t('dashboard.label.monthly_transactions') }}-->
<!--                                    <h5 class="fix-margin">-->
<!--                                        {{ starshop_data.admin_data.ivr.monthly_tr }}-->
<!--                                        <span style="font-size: 1.2rem">-->
<!--                                                    {{ ' ' + $t('currency.rial') }}-->
<!--                                                </span>-->
<!--                                    </h5>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-4">-->
<!--                            <div class="card mb-3 bg-gr-bluvio">-->
<!--                                <div class="card-body">-->
<!--                                    {{ $t('dashboard.label.total_transactions') }}-->
<!--                                    <h5 class="fix-margin">-->
<!--                                        {{ starshop_data.admin_data.ivr.total_tr }}-->
<!--                                        <span style="font-size: 1.2rem">-->
<!--                                                    {{ ' ' + $t('currency.rial') }}-->
<!--                                                </span>-->
<!--                                    </h5>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-4">-->
<!--                            <div class="card mb-3 bg-gr-ored">-->
<!--                                <div class="card-body">-->
<!--                                    {{ $t('dashboard.label.balance') }}-->
<!--                                    <h5 class="fix-margin">-->
<!--                                        {{ starshop_data.admin_data.ivr.balance }}-->
<!--                                        <span style="font-size: 1.2rem">-->
<!--                                                    {{ ' ' + $t('currency.rial') }}-->
<!--                                                </span>-->
<!--                                    </h5>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-4">-->
<!--                            <div class="card mb-3 bg-gr-midivio">-->
<!--                                <div class="card-body">-->
<!--                                    {{ $t('dashboard.label.settling_balance') }}-->
<!--                                    <h5 class="fix-margin">-->
<!--                                        {{ starshop_data.admin_data.ivr.settling }}-->
<!--                                        <span style="font-size: 1.2rem">-->
<!--                                                    {{ ' ' + $t('currency.rial') }}-->
<!--                                                </span>-->
<!--                                    </h5>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="col-md-4">-->
<!--                            <div class="card mb-3 bg-gr-pinkp">-->
<!--                                <div class="card-body">-->
<!--                                    {{ $t('dashboard.label.settled_balance') }}-->
<!--                                    <h5 class="fix-margin">-->
<!--                                        {{ starshop_data.admin_data.ivr.settled }}-->
<!--                                        <span style="font-size: 1.2rem">-->
<!--                                                    {{ ' ' + $t('currency.rial') }}-->
<!--                                                </span>-->
<!--                                    </h5>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
export default {
    name: "starshop_data",

    props: {
        starshop_data: {
            default() {
                return {}
            }
        },
    },
    methods: {
        _countUserGate() {
            let count = 1;
            if (this.starshop_data.admin_data.collective) {
                count += 1;
            }
            if (this.starshop_data.admin_data.ivr) {
                count += 1;
            }
            return count;
        },
        refreshData() {
            this.$store.dispatch('starshopDashboard/refreshStarshopDashboard');
        }
    },
    mounted() {
    }
}
</script>

<style>
.line-divider {
    height: 1px;
    background-color: #777;
}
</style>